define((require) => {
    "use strict";

    const $                  = require("jquery");
    const AbstractWidgetView = require("shared/ui/experience/widgets/AbstractWidgetView");

    /**
     * The view rendering a product widget.
     *
     * @class ProductWidgetView
     * @constructor
     *
     * @cfg {ProductWidgetModel} model The model of the link widget being rendered.
     */
    return AbstractWidgetView.extend("ProductWidgetView", {

        _$placeholderElement: null,

        className: `${AbstractWidgetView.prototype.className} product-widget`,

        updateRendering(element, bounds, active, edited) {
            if (edited) {
                if (this._$placeholderElement === null) {
                    const icon =  this.model.get("icon");
                    this._$placeholderElement = $(`<div class="placeholder ${icon}"></div>`)
                        .appendTo(element);
                }
            } else {
                // IE 10 and below does not handle overlayed widgets correctly unless they have
                // a background.
                element.css({
                    backgroundColor: "#fff",
                    opacity: 0
                });
            }
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/productWidget/ProductWidgetView.js